import { render } from "./CulturalRegionsSection.vue?vue&type=template&id=57df41e0&scoped=true"
import script from "./CulturalRegionsSection.vue?vue&type=script&lang=js"
export * from "./CulturalRegionsSection.vue?vue&type=script&lang=js"

import "./CulturalRegionsSection.vue?vue&type=style&index=0&id=57df41e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57df41e0"]])

export default __exports__